import "./_style.scss";
import { useContext, useEffect, useState, useRef } from "react";
import { fakeTableList } from "./parts";
import { useLocation, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import { GlobalContext } from "../../context/globalContext";
import TkMemo from "../../components/molecules/TkMemo";
import { httpAPI_ACC005, httpAPI_APP016 } from "./api/request";
import { IAPI_ACC005_Request } from "../../type/apiType";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import TkBackButton from "../../components/molecules/TkBackButton";
import { TkGetCode } from "../../utils/TkGetCode";
import { Prefectures, applyEvent } from "../../assets/data/Constants";
import _ from "lodash";

/**
 * SCRW010001 登録メールアドレスの変更届
 * @returns JSX.Element
 */
const SCRW010001 = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const [stateFakeTableList, setStateFakeTableList] = useState<any>([]);
  const [memoData, setMemoData] = useState("");
  const [contractorNo, setContractorNo] = useState<string>();
  const [memoCheck, setMemoCheck] = useState(false);
  const applyId: number = location.state?.applyId;
  const [status, setStatus] = useState<any>();
  const [bodyList, setBodyList] = useState<any>();
  const stateFakeTableListRef = useRef(_.cloneDeep(fakeTableList));

  const handleInit = async () => {
    const requestData: IAPI_ACC005_Request = {
      applyId: applyId,
    };
    try {
      const res = await httpAPI_ACC005({
        ...requestData,
      });
      if (res.resultCd === "I0000") {
        let resArr = stateFakeTableListRef.current;
        setStatus(res.applyStatus);
        setContractorNo(res.contractorNo);
        let mutualAidContractNumber = resArr.find(
          (item) => item.keyword === "mutualAidContractNumber"
        )!;
        let mutualAidPolicyholderName = resArr.find(
          (item) => item.keyword === "mutualAidPolicyholderName"
        )!;
        let zipcode = resArr.find((item) => item.keyword === "zipcode")!;
        let address = resArr.find((item) => item.keyword === "address")!;
        let personInChargeName = resArr.find(
          (item) => item.keyword === "personInChargeName"
        )!;
        let emailAddressUsedInThisSystem = resArr.find(
          (item) => item.keyword === "emailAddressUsedInThisSystem"
        )!;
        let emailAddressUsedInThisSystemForConfirmation = resArr.find(
          (item) =>
            item.keyword === "emailAddressUsedInThisSystemForConfirmation"
        )!;
        let contactPhoneNumber = resArr.find(
          (item) => item.keyword === "contactPhoneNumber"
        )!;
        let contactFAX = resArr.find((item) => item.keyword === "contactFAX")!;
        let others = resArr.find((item) => item.keyword === "others")!;
        const valueObject: any = {
          prefectures: TkGetCode(Prefectures, res.prefectureCd),
          city: res.addressCity,
          address: res.addressOthers,
        };
        mutualAidContractNumber.setDefaultValue = res.contractorNo;
        mutualAidPolicyholderName.setDefaultValue = res.contractorName;
        zipcode.setDefaultValue = res.zipcode;
        address.valueObject = valueObject;
        personInChargeName.setDefaultValue = res.name;
        emailAddressUsedInThisSystem.setDefaultValue = res.email;
        emailAddressUsedInThisSystemForConfirmation.setDefaultValue = res.email;
        contactPhoneNumber.setDefaultValue = res.tel;
        contactFAX.setDefaultValue = res.fax;
        others.setDefaultValue = res.notices;
        setStateFakeTableList(resArr);

        const bodyListData = res.processingStatusList?.map((item) => [
          { children: item.personnel },
          { children: item.processingStatus },
          { children: item.processingDate },
          { children: item.comment },
        ]);
        setBodyList(bodyListData ?? []);

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleBtnClick = async (btnName: keyof typeof applyEvent) => {
    const applyEventNo = applyEvent[btnName];
    if (
      ![
        applyEvent["受理"],
        applyEvent["契約者に差戻し"],
        applyEvent["上長承認"],
        applyEvent["担当者に差戻し"],
        applyEvent["課長代理確認"],
      ].includes(applyEventNo)
    )
      return;

    let reqData: any = {
      applyId: applyId,
      applyEvent: applyEventNo,
      contractorNo: contractorNo,
      reason: memoData,
      screenId: "SCRW010001",
    };
    memoCheck && (reqData.inquiryCode = "1");

    try {
      const res = await httpAPI_APP016({
        ...reqData,
      });

      if (res.resultCd === "I0000") {
        navigate("/SCRC070008");
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };
  const onChange = (event: any) => {
    switch (event.target.type) {
      case "input":
        setMemoData(event.target.value);
        break;
      case "checkbox":
        setMemoCheck(event.target.value);
        break;
    }
  };
  return (
    <Box className="SCRW010001" data-testid="SCRW010001PageForTest">
      <TkKikoStepper
        applicationFlowType="TYPE3"
        businessType="JOB-76"
        applicationStatus={status}
      />

      <TkFakeTable
        list={stateFakeTableList}
        ruleSchema={{}}
        showButton={false}
      />

      <TkMemo bodyList={bodyList} onChange={onChange} />

      <Box className="buttonGroup">
        <TkBackButton mr />
        <TkViewButtonJudgement
          flowType="TYPE3"
          Status={status}
          onClick={handleBtnClick}
        />
      </Box>
    </Box>
  );
};

export default SCRW010001;
